import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable, Injector } from '@angular/core'
import { EMPTY, Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { OpenAuthenticationService } from '@core/services/oauth.service'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  // Resolve the auth service lazily via the Injector (not constructor injection) to avoid a DI cycle:
  // OpenAuthenticationService → OAuthService → HttpClient → HTTP_INTERCEPTORS (this).
  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          // Token rejected/expired → kick off a clean re-authentication (redirect to login, returning here
          // afterward) rather than leaving the UI half-broken. Swallow the error since we're navigating away
          // (and it's guarded, so concurrent 401s only redirect once).
          this.injector.get(OpenAuthenticationService).reauthenticate()
          return EMPTY
        }

        if (err.status === 404) {
          return throwError(
            () => 'Unable to perform this operation: the requested resource could not be located.'
          )
        }

        // Pass the structured HttpErrorResponse through UNCHANGED so callers can read the full Result envelope
        // ({ isSuccess, errors: [{ code, message }] }), not just a flattened message. Flattening here discarded the
        // error CODE, which broke code-driven handling (e.g. the roles form keys "Restore and edit" off
        // Role.PermissionSetCollidesWithDeleted). Consumers use extractApiError() to get a human message from
        // whatever shape reaches them (string | HttpErrorResponse | envelope).
        return throwError(() => err)
      })
    )
  }
}
